/** Product boundaries are routing hints, never authorization grants.
 * Realty Max is a future town square. Its active workspace must not silently
 * become another business's identity or write target.
 */
export function productForHost(hostname: string): 'bliss' | 'realtimax' | null {
  const host = hostname.toLowerCase().replace(/\.$/, '')
  if (host === 'blissbunkbeds.com' || host.endsWith('.blissbunkbeds.com')) return 'bliss'
  if (host === 'realtimax.com' || host.endsWith('.realtimax.com')) return 'realtimax'
  return null
}
export function defaultTenantSlug(hostname: string): string | null {
  const product = productForHost(hostname)
  // Preserve the existing Realty Max host mapping; ecosystem membership does
  // not imply ownership or permit aggregating unrelated business records.
  return product === 'bliss' ? 'bliss-bedrooms' : product === 'realtimax' ? 'renovation-flooring' : null
}
export function tenantOverrideForLocation(location: { hostname: string; pathname: string; search: string }, legacyId: string | null): string | null {
  if (!productForHost(location.hostname)) return legacyId
  const params = new URLSearchParams(location.search)
  const workspaceRoute = location.pathname === '/admin' || location.pathname.startsWith('/admin/') || location.pathname === '/platform'
  if (!workspaceRoute || params.get('workspace') !== 'tenant') return null
  const id = params.get('tenant')
  return id && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) ? id : null
}
/** Keeps workspace selection local to this URL; does not mutate a global profile preference. */
export function tenantWorkspaceUrl(pathname: string, search: string, tenantId: string): string {
  const params = new URLSearchParams(search)
  params.set('workspace','tenant'); params.set('tenant',tenantId)
  return `${pathname}?${params.toString()}`
}
